import React, { useState } from 'react';
import { FormGroup, Form, Input, Button, Spinner, InputGroup, InputGroupText } from 'reactstrap';
import { useAuth } from './../../hooks/useAuth';
import { FaEye, FaEyeSlash, FaKey, FaRegUser, FaUser } from 'react-icons/fa';
import { BsPerson } from 'react-icons/bs';
import { MdOutlineVpnKey } from 'react-icons/md';
import './style.css';

export const Login = (): React.JSX.Element => {
  const [cpf, setCPF] = useState('');
  const [password, setPassword] = useState('');
  const [errorCPF, setErrorCPF] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  const { signIn, loading } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  async function handleSubmitLogin(): Promise<void> {
    if (cpf?.length !== 14) {
      setErrorCPF('CPF obrigatório.');
    } else {
      setErrorCPF('');
    }
    if (password === '') {
      setErrorPassword('Senha obrigatória.');
    } else {
      setErrorPassword('');
    }
    if (cpf?.length === 14 && password !== '') {
      await signIn({ cpf, password });
    }
  }

  function cpfMask(value: string): string {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: '#edf3ff',
      }}
    >
      {/* Imagem lateral */}
      <div
        className="d-none d-md-block"
        style={{
          width: '50%',
          height: '100vh',
        }}
      >
        <img
          src="/assets/sideImage.png"
          alt="icone-amapa"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </div>

      {/* Formulário */}
      <div
        className="col-sm"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <div
          className="col-sm-7"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: 20,
            height: '100%',
            marginTop: -90,
          }}
        >
          {/* Logo */}
          <div>
            <img
              src="/assets/logo.png"
              alt="icone-amapa"
              className="logo"
              // style={{
              //   width: '100%', // ocupa todo o espaço possível
              //   maxWidth: '330px', // não passa disso
              //   height: 'auto', // mantém proporção
              //   objectFit: 'cover',
              // }}
            />
          </div>

          {/* Card do formulário */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: '#fff',
              borderRadius: 12,
              padding: '30px 20px',
              width: '100%',
              maxWidth: 562,
              minHeight: 456,
              gap: 20,
            }}
          >
            <div style={{ marginBottom: 25, textAlign: 'center' }}>
              <h5 style={{ fontWeight: 500, fontSize: 45 }}>Bem-vindo de volta!</h5>
              <span>Informe seus dados para fazer o login no sistema</span>
            </div>

            <Form style={{ width: '100%' }}>
              {/* CPF */}
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                  <InputGroup>
                    <InputGroupText
                      className="no-border-right"
                      style={{
                        backgroundColor: 'transparent', // fundo transparente
                        color: '#2A2C85', // cor do ícone
                        borderRight: 'none', // remove a borda da direita
                        borderColor: errorCPF?.length > 1 ? '#E44B39' : '#989898',
                      }}
                    >
                      <BsPerson /> {/* ícone react-icons */}
                    </InputGroupText>
                    <Input
                      className="no-border-left"
                      style={{
                        borderColor: errorCPF?.length > 1 ? '#E44B39' : '#989898',
                        height: 48,
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                      }}
                      value={cpf}
                      placeholder="000.000.000-00"
                      type="text"
                      onChange={(e) => setCPF(cpfMask(e.target.value))}
                      onKeyPress={async (e) => {
                        if (e.charCode === 13 && !loading) {
                          await handleSubmitLogin();
                        }
                      }}
                    />
                  </InputGroup>

                  <div
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginTop: 5,
                    }}
                  >
                    {errorCPF}
                  </div>
                </FormGroup>
              </div>

              {/* Senha */}
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                  <InputGroup style={{ width: '100%' }}>
                    <InputGroupText
                      className="no-border-right"
                      style={{
                        backgroundColor: 'transparent', // fundo transparente
                        color: '#2A2C85', // cor do ícone
                        borderRight: 'none', // remove a borda da direita
                        borderColor: errorPassword.length > 1 ? '#E44B39' : '#989898',
                      }}
                    >
                      <MdOutlineVpnKey />
                    </InputGroupText>
                    <Input
                      className="no-border-left-password"
                      style={{
                        borderColor: errorPassword.length > 1 ? '#E44B39' : '#989898',
                        height: 48,
                      }}
                      placeholder="Insira sua senha"
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyPress={async (e) => {
                        if (e.charCode === 13 && !loading) {
                          await handleSubmitLogin();
                        }
                      }}
                    />
                    <InputGroupText
                      style={{
                        backgroundColor: 'transparent', // fundo transparente
                        color: '#2A2C85', // cor do ícone
                        cursor: 'pointer',
                        borderLeft: 'none',
                        borderColor: errorPassword.length > 1 ? '#E44B39' : '#989898',
                      }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash color="#C6C6C6" /> : <FaEye color="#C6C6C6" />}
                    </InputGroupText>
                  </InputGroup>
                  <div
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginTop: 5,
                    }}
                  >
                    {errorPassword}
                  </div>
                </FormGroup>
              </div>

              {/* Links */}
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    maxWidth: 452,
                    marginBottom: 30,
                  }}
                >
                  <a href="/register" style={{ textDecoration: 'none', color: '#989898' }}>
                    Crie uma conta
                  </a>
                  <a href="/forgotPassword" style={{ textDecoration: 'none', color: '#989898' }}>
                    Esqueceu a senha?
                  </a>
                </div>
              </div>

              {/* Botão */}
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  disabled={loading}
                  onClick={handleSubmitLogin}
                  style={{
                    width: '100%',
                    maxWidth: 452,
                    backgroundColor: '#2A2C85',
                    color: '#fff',
                    height: 48,
                  }}
                >
                  {loading ? <Spinner type="border" size={'sm'} color="light" /> : 'Entrar'}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};
